import { DeleteOutlined, LoadingOutlined, PlusCircleOutlined, SearchOutlined } from '@ant-design/icons';
import { Button, Col, Form, Input, Radio, Row, Space, Spin } from 'antd';
import { useEffect, useState } from 'react';
import { format, validate } from 'rut.js';
import { useFormContext } from '../../Context/DeclarationContext';
import { phoneNumberCountryType } from '../../Interfaces/Declaration.Interface';
import { getShortId, validateRut } from '../../Services/declarations';
import { formatRUT } from '../../utils/generals';
import FormInputPhone2 from '../Inputs/Form_Input_Phone/form_input_phone2';
import './declarant_form.scss';

type Props = {
  rutNotExist: boolean;
  setRutNotExist: React.Dispatch<React.SetStateAction<boolean>>;
};

const formatRut = (rut: string) => {
  const formated = format(rut);
  return formated === '-' ? undefined : formated;
};

export const DeclarantFormComponent = (props: Props) => {
  const { state, dispatch } = useFormContext();
  const [hoverSearchButton, setHoverSearchButton] = useState(false);
  const [optionIdentifierTypeClient, setOptionIdentifierTypeClient] = useState(state.declarant?.identifierTypeClient || 'rut');
  const [optionIdentifierTypeDeclarante, setOptionIdentifierTypeDeclarante] = useState(state.declarant?.identifierType || 'rut');
  const [disabledSearchButton, setDisabledSearchButton] = useState(true);
  const [element_form] = Form.useForm();
  const [loadingSearch, setLoadingSearch] = useState(false);
  const [rut, setRut] = useState('');
  const [rutClient, setRutClient] = useState('');

  const onChangeIdentifierTypeDeclarante = (e: any) => {
    const valueType = e.target.value;
    setOptionIdentifierTypeDeclarante(valueType);
    // setRutClient(e.target.value);
    console.log('onChangeIdentifierTypeDeclarante');

    element_form.setFieldsValue({ declarantIdentityNumber: undefined });
    // element_form.validateFields(['declarantIdentityNumber']);
    // const declarantIdentityNumber = element_form.getFieldValue('declarantIdentityNumber');
    // if (valueType === 'rut') {
    //   element_form.setFieldValue('declarantIdentityNumber', formatRut(declarantIdentityNumber));
    // } else {
    //   element_form.setFieldValue('declarantIdentityNumber', declarantIdentityNumber?.replace(/[.-]/g, ''));
    // }
  };

  const onChangeIdentifierTypeClient = (e: any) => {
    const valueType = e.target.value;
    setOptionIdentifierTypeClient(valueType);
    element_form.setFieldsValue({ customerIdentityNumber: undefined });
  };

  useEffect(() => {
    console.log('useEffect is running');

    dispatch({
      type: 'SET_HEADER_TITLE',
      payload: 'Declaración de siniestros',
    });
  }, []);

  useEffect(() => {
    dispatch({
      type: 'UPDATE_CURRENT_FORM_ELEMENT',
      payload: element_form,
    });
  }, [state.step]);

  useEffect(() => {
    const setShortId = async () => {
      const { data } = await getShortId();
      dispatch({
        type: 'UPDATE_SHORT_ID',
        payload: data?.shortId,
      });
    };
    if (!state.shortId) setShortId();
  }, []);

  useEffect(() => {
    if (state.declarant?.customerIdentityNumber) {
      element_form.setFieldsValue({
        customerIdentityNumber:
          optionIdentifierTypeClient === 'rut'
            ? formatRUT(state?.declarant?.customerIdentityNumber ?? '', { dots: true })
            : state.declarant?.customerIdentityNumber,
        customerName: state.declarant?.customerName,
        identifierTypeClient: optionIdentifierTypeClient,

        identifierType: optionIdentifierTypeDeclarante,
        declarantIdentityNumber:
          optionIdentifierTypeDeclarante === 'rut'
            ? formatRUT(state?.declarant?.declarantIdentityNumber ?? '', { dots: true })
            : state?.declarant?.declarantIdentityNumber, // Remueve puntos y guiones si la opción no es 'rut'

        declarantFullName: state.declarant?.declarantFullName,
        phoneNumber: state.declarant?.phoneNumber,
        emails:
          (state.declarant?.emails?.length ?? [].length) > 0 ? state.declarant?.emails?.map((email: any) => ({ email: email })) : [{ email: '' }],
      });
    } else {
      element_form.setFieldsValue({
        customerName: state.declarant?.customerName,
        identifierTypeClient: optionIdentifierTypeClient,
        identifierType: optionIdentifierTypeDeclarante,

        declarantIdentityNumber:
          optionIdentifierTypeDeclarante === 'rut'
            ? formatRUT(state?.declarant?.declarantIdentityNumber ?? '', { dots: true })
            : state?.declarant?.declarantIdentityNumber, // Remueve puntos y guiones si la opción no es 'rut'

        declarantFullName: state.declarant?.declarantFullName,
        phoneNumber: state.declarant?.phoneNumber,
        emails:
          (state.declarant?.emails?.length ?? [].length) > 0 ? state.declarant?.emails?.map((email: any) => ({ email: email })) : [{ email: '' }],
      });
    }
  }, []);

  const onFinish = (values: any) => {
    console.log('Success:', values);
    dispatch({
      type: 'UPDATE_DECLARANT',
      payload: values,
    });
  };

  const onChangeValues = (changedValues: any, allValues: any) => {
    const emails = allValues?.emails?.map((email: any) => email?.email);
    allValues.emails = emails;

    const phoneNumber = allValues.phoneNumber as phoneNumberCountryType;
    if (!phoneNumber.phone_code) {
      allValues.phoneNumber = { ...allValues.phoneNumber, phone_code: '+56' };
    }

    dispatch({
      type: 'UPDATE_DECLARANT',
      payload: allValues,
    });
  };

  const rutValidator = async (rut: string, patente: string) => {
    const response = await validateRut(rut, patente || '');
    console.log('validateRut', response);

    return response;
  };

  const getColorSearchButton = () => {
    if (disabledSearchButton) {
      return 'rgba(45, 45, 45, 0.6)';
    } else if (hoverSearchButton) {
      return '#FFF';
    } else {
      return '#22B260';
    }
  };

  return (
    <div
      style={{
        marginTop: '24px',
      }}
      className="declarant_form"
    >
      <div className="title">1. Datos declarante</div>
      <div className="sub_title">Debe completar toda la información de manera obligatoria.</div>

      <Row style={{ marginBottom: '-10px', marginTop: '45px', fontWeight: '600' }}>Información del cliente</Row>
      <Form onFinish={onFinish} colon={false} form={element_form} onValuesChange={onChangeValues}>
        <Row
          style={{
            marginTop: '24px',
          }}
          gutter={[24, 24]}
          justify="center"
        >
          <Col sm={8} xs={24}>
            <Form.Item label="Seleccionar documento identificador" name="identifierTypeClient">
              <Radio.Group onChange={onChangeIdentifierTypeClient} defaultValue={optionIdentifierTypeClient}>
                <Radio value={'rut'}>RUT</Radio>
                <Radio value={'pasaporte'}>
                  Pasaporte
                </Radio>
              </Radio.Group>
            </Form.Item>
          </Col>

          <Col sm={8} xs={24}>
            <div>
              <Space.Compact block>
                <Form.Item
                  required
                  label="RUT o Pasaporte del cliente"
                  name="customerIdentityNumber"
                  style={{
                    width: '90%',
                  }}
                  rules={[
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        const identifierType = getFieldValue('identifierTypeClient');
    
                        if (identifierType === 'rut') {
                          if (!value) {
                            return Promise.reject(new Error('Ingrese el RUT.'));
                          } else if (!validate(value)) {
                            return Promise.reject(new Error('El RUT ingresado es inválido.'));
                          }
                        }
    
                        if (identifierType === 'pasaporte') {
                          if (!value) {
                            return Promise.reject(new Error('Ingrese el pasaporte.'));
                          }
                        }
    
                        return Promise.resolve();
                      },
                    }),
                  ]}
                  normalize={element_form.getFieldValue('identifierTypeClient') === 'rut' ? (value) => formatRUT(value, { dots: true }) : undefined}
                >
                  <Input placeholder={rut === 'rut' ? 'Ejemplo: 11111111-1' : 'Ejemplo: 123456789'} maxLength={15} />
                </Form.Item>

                <Button
                  type="primary"
                  size="large"
                  style={{
                    border: 'none',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    marginTop: 32,
                  }}
                  icon={
                    loadingSearch ? (
                      <Spin
                        indicator={
                          <LoadingOutlined
                            style={{
                              color: 'white',
                            }}
                            spin
                          />
                        }
                      />
                    ) : (
                      <SearchOutlined style={{ color: getColorSearchButton() }} />
                    )
                  }
                  onClick={async () => {
                    const rutValue = element_form.getFieldValue('customerIdentityNumber');
                    const rut = rutValue?.replace(/[.]/g, '');
                    const patente = state?.vehiclePatente?.deviceId;

                    if (rut) {
                      element_form.setFieldValue('customerName', '');
                      let responseRUT: any = null;
                      setLoadingSearch(true);
                      try {
                        responseRUT = await rutValidator(rut, patente || '');
                      } catch (error) {
                        responseRUT = error;
                      }

                      console.log('responseRUT', responseRUT);

                      setLoadingSearch(false);

                      if (responseRUT?.status >= 400) {
                        props.setRutNotExist(true);
                      } else {
                        const { data } = responseRUT;
                        props.setRutNotExist(false);
                        element_form.setFieldValue('customerName', data?.Nombre_Cliente);
                      }
                    }
                  }}
                  // onMouseEnter={() => {
                  //   setHoverSearchButton(true);
                  // }}
                  // onMouseLeave={() => {
                  //   setHoverSearchButton(false);
                  // }}
                />
              </Space.Compact>
            </div>
            {/* {props.rutNotExist ? (
              <small
                className="notExist"
                style={{
                  marginTop: '-5px',
                  display: 'block',
                  color: '#FF3200',
                  fontSize: '12px',
                  fontWeight: '400',
                  fontFamily: 'Roboto',
                }}
              >
                Rut ingresado no está en nuestra base de datos.
              </small>
            ) : null} */}
          </Col>
          <Col sm={8} xs={24}>
            <Form.Item
              label="Nombre completo/Razón social"
              name="customerName"
              rules={[
                {
                  required: true,
                  message: 'Debe ingresar el nombre completo o razón social',
                },
                {
                  pattern: /^[A-Za-zÑñÁáÉéÍíÓóÚúÜü&\s0-9.-]+$/,
                  message: 'Los nombres no pueden incluir caracteres especiales',
                },
                {
                  max: 200,
                  message: 'Debe tener máximo 200 caracteres',
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>

        <Row style={{ marginBottom: '20px', fontWeight: '600' }}>Información del declarante</Row>

        <Row gutter={[24, 24]}>
          <Col sm={8} xs={24}>
            <Form.Item label="Seleccionar documento identificador" name="identifierType">
              <Radio.Group onChange={onChangeIdentifierTypeDeclarante} defaultValue={optionIdentifierTypeDeclarante}>
                <Radio value={'rut'}>RUT</Radio>
                <Radio value={'pasaporte'}>Pasaporte</Radio>
              </Radio.Group>
            </Form.Item>
          </Col>

          <Col sm={8} xs={24}>
            <Form.Item
              required={true}
              label="RUT o Pasaporte del declarante"
              name="declarantIdentityNumber"
              dependencies={['identifierType']}
              rules={[
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    const identifierType = getFieldValue('identifierType');

                    if (identifierType === 'rut') {
                      if (!value) {
                        return Promise.reject(new Error('Ingrese el RUT.'));
                      } else if (!validate(value)) {
                        return Promise.reject(new Error('El RUT ingresado es inválido.'));
                      }
                    }

                    if (identifierType === 'pasaporte') {
                      if (!value) {
                        return Promise.reject(new Error('Ingrese el pasaporte.'));
                      }
                    }

                    return Promise.resolve();
                  },
                }),
              ]}
              normalize={element_form.getFieldValue('identifierType') === 'rut' ? (value) => formatRUT(value, { dots: true }) : undefined}
            >
              <Input placeholder={rutClient === 'rut' ? 'Ejemplo: 11111111-1' : 'Ejemplo: 123456789'} maxLength={15} />
            </Form.Item>
          </Col>
          <Col sm={8} xs={24}>
            <Form.Item
              label="Nombre completo del declarante"
              name="declarantFullName"
              rules={[
                {
                  required: true,
                  message: 'Debe ingresar el nombre completo del declarante',
                },
                {
                  pattern: /^[A-Za-zÑñÁáÉéÍíÓóÚúÜü&\s0-9.-]+$/,
                  message: 'Los nombres no pueden incluir caracteres especiales',
                },
                {
                  max: 200,
                  message: 'Debe tener máximo 200 caracteres',
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={[24, 24]}>
          <Col sm={8} xs={24}>
            <FormInputPhone2
              prevalue={state.declarant?.phoneNumber ?? { phone_code: '+56', stringValue: '' }}
              label="Teléfono del declarante"
              name="phoneNumber"
              messageForRequired="Debe ingresar el Teléfono del declarante"
            />
          </Col>

          <Col sm={8} xs={24}>
            <Form.List
              name="emails"
              // label='Correo electrónico del declarante'
            >
              {(fields, { add, remove }) => (
                <>
                  {fields.map(({ key, name, ...restField }, index) => (
                    <>
                      <Form.Item
                        key={key}
                        {...restField}
                        name={[name, 'email']}
                        label={`Correo electrónico  ${name + 1} del declarante`}
                        rules={[
                          {
                            required: true,
                            message: 'Debe ingresar el Correo electrónico',
                          },
                          {
                            type: 'email',
                            message: 'El correo electrónico no es válido',
                          },
                          {
                            max: 80,
                            message: 'Debe tener máximo 80 caracteres',
                          },
                        ]}
                      >
                        {fields.length > 1 ? (
                          <Input
                            addonAfter={
                              <Button
                                type="text"
                                onClick={() => {
                                  remove(name);
                                }}
                              >
                                <DeleteOutlined
                                  style={{
                                    fontSize: '16px',
                                  }}
                                />
                              </Button>
                            }
                          />
                        ) : (
                          <Input />
                        )}
                      </Form.Item>
                    </>
                  ))}

                  <Form.Item>
                    <a className="addEmail-btn" onClick={() => add()}>
                      <PlusCircleOutlined className="addEmail-icon" />
                      Agregar otro correo
                    </a>
                  </Form.Item>
                </>
              )}
            </Form.List>
          </Col>
        </Row>
      </Form>
    </div>
  );
};
